import React from 'react';
import { Divider, Flex, Image, useTheme, Text } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';

import Footer from 'components/Authenticator/components/Footer';

import bgImage from './bgImage.svg';

const Maintenance = ({ maintenanceTimeEnd }) => {
  const { tokens } = useTheme();

  return (
    <Flex direction="column" alignItems="center" justifyContent="space-between" height="100vh">
      <Divider height={8} backgroundColor={tokens.colors.brand.secondary[80]} opacity="1" border="none" />
      <Flex direction="column" alignItems="center" gap="0">
        <Image alt="maintenance" src={bgImage} marginBottom="32px" />
        <Text color="#212121" fontSize={tokens.fontSizes.xl} marginBottom={tokens.space.medium}>
          {I18n.get('maintenance.title')}
        </Text>
        <Text color="#666666" fontSize={tokens.fontSizes.medium}>
          {I18n.get('maintenance.subtitle')}
        </Text>
        <Text color={tokens.colors.brand.primary[80]} fontSize="48px" fontWeight={tokens.fontWeights.medium}>
          {new Date(maintenanceTimeEnd).toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </Text>

        <Text color="#666666" fontSize={tokens.fontSizes.medium}>
          {I18n.get('maintenance.subtitle2')}
        </Text>
      </Flex>
      <Footer style={{ position: 'initial' }} />
    </Flex>
  );
};

export default Maintenance;
